import { Dispatch, useCallback } from "react";
import {
  VeterinarioActions,
  VeterinarioActionUnion,
} from "./Veterinario.Actions";
import VeterinarioService from "../../Data/Services/VeterinarioService";
import { IVeterinarioEffects } from "./Interfaces/IVeterinarioEffects";

export type VeterinarioEffectsType = (
  dispatch: Dispatch<VeterinarioActionUnion>
) => IVeterinarioEffects;

export const VeterinarioEffects: VeterinarioEffectsType = (
  dispatch: Dispatch<VeterinarioActionUnion>
) => ({
  getAllVeterinarios: useCallback(async () => {
    try {
      dispatch(VeterinarioActions.setLoading(true));
      const { data } = await VeterinarioService.fetchAllVeterinarios();
      dispatch(VeterinarioActions.getAllVeterinariosSuccess(data));
      window.setInterval(function () {
        dispatch(VeterinarioActions.nextPageVets());
      }, 7000);
    } catch (err: any) {
    } finally {
      dispatch(VeterinarioActions.setLoading(false));
    }
  }, [dispatch]),
});
